import { AccomodationDto } from "./accomodation.dto";

export class LocationDto {

    constructor(
      public id?: number,
      public fullAddress?: string,
      public city?: string,
      public country?: string,
      public latitude?: number,
      public longitude?: number,
      public accomodation?: AccomodationDto
    ){}
}
